import * as React from 'react';
import { Card, CounterBadge, Box, Heading } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';
export function CompleteSetupHeader({ badgeCounter, }) {
    const t = useTranslation();
    return (React.createElement(Card.Header, { title: React.createElement(Box, { verticalAlign: "middle" },
            React.createElement(Box, { marginRight: "10px" },
                React.createElement(Heading, { appearance: "H3", dataHook: "manage-apps-pending-title" }, t('manage-apps.complete-setup-apps.card-header.action-required'))),
            React.createElement(CounterBadge, { skin: "danger", dataHook: "manage-apps-counter-badge" }, badgeCounter)) }));
}
//# sourceMappingURL=complete-setup.apps-section-header.js.map